import React from 'react';
import { Row, Col, Input, Button, Typography } from 'antd';
import { InboundPackages } from '../Inbound';
import { OutboundPackages } from '../outbound';
import { FilterPanel } from './filters';
import { useWarehouseOperations } from './useWarehouseOperations';
import { FilterIcon } from 'components/common/icons';
import styles from './styles.module.scss';

const { Search } = Input;
const { Title } = Typography;

export const WarehouseOperations: React.FC = () => {
  const {
    searchValue,
    filterDrawerOpen,
    inboundFilters,
    outboundFilters,
    isInbound,
    isOutbound,
    handleSearch,
    handleFilterClick,
    handleFilterClose,
    handleInboundFiltersApply,
    handleOutboundFiltersApply,
    handleNavigateToInbound,
    handleNavigateToOutbound,
  } = useWarehouseOperations();

  return (
    <div className={styles.warehouseOperations}>
      <div className={styles.header}>
        <Title level={3} className={styles.title}>
          Orders
        </Title>
      </div>

      <div className={styles.navigationButtons}>
        <Row gutter={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
          <Col xs={12} sm={12} md="auto">
            <Button
              className={`${styles.navButton} ${isInbound ? styles.active : ''}`}
              onClick={handleNavigateToInbound}
            >
              Inbound Packages
            </Button>
          </Col>
          <Col xs={12} sm={12} md="auto">
            <Button
              className={`${styles.navButton} ${isOutbound ? styles.active : ''}`}
              onClick={handleNavigateToOutbound}
            >
              Outbound Packages
            </Button>
          </Col>
        </Row>
      </div>

      <div className={styles.searchContainer}>
        <Search
          enterButton={false}
          size="large"
          placeholder="Search by Order ID"
          className={styles.searchInput}
          allowClear
          value={searchValue}
          onChange={(e) => handleSearch(e.target.value)}
        />
        <Button size="large" color="default" variant="filled" onClick={handleFilterClick} icon={<FilterIcon />} />
      </div>

      <div className={styles.tabContent}>
        {isInbound && <InboundPackages key="inbound" searchValue={searchValue} filters={inboundFilters} />}
        {isOutbound && <OutboundPackages key="outbound" searchValue={searchValue} filters={outboundFilters} />}
      </div>

      <FilterPanel
        open={filterDrawerOpen}
        onClose={handleFilterClose}
        type={isInbound ? 'inbound' : 'outbound'}
        onApplyInbound={handleInboundFiltersApply}
        onApplyOutbound={handleOutboundFiltersApply}
        initialInboundFilters={inboundFilters}
        initialOutboundFilters={outboundFilters}
      />
    </div>
  );
};
